import {Component, OnInit, ViewChild} from '@angular/core';
import {CARDGROUPINFO, CARDINFO, POOLINFO} from '../../../gen/swagger-api';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';
import {CardDetailsModalComponent} from '../modals/card-details/card-details-modal.component';
import {AuditModalComponent} from '../modals/audit-modal/audit-modal.component';
import {HistoryModalComponent} from '../modals/history-modal/history-modal.component';
import {AlertService} from '../../shared/services/alert.service';
import {HttpOperationsService} from '../../shared/services/http-operations.service';
import {DeleteQuestionModalComponent} from '../modals/delete-question-modal/delete-question-modal.component';
import {SubscriptionService} from '../../shared/services/subscription.service';
import {CARDGROUPINFOCUSTOM} from './cARDGROUPINFOCUSTOM';
import {DefaultServiceGetSubscriptionPools} from '../../shared/services/workaround/default-service-get-subscription-pools.service';
import {HttpErrorResponse} from '@angular/common/http';
import {ImportCardsModalComponent} from '../modals/import-cards-modal/import-cards-modal.component';
import {ScDeleteCardsModalComponent} from '../modals/sc-delete-cards-modal/sc-delete-cards-modal.component';
import {SelectionOperationModalComponent} from '../modals/selection-operation-modal/selection-operation-modal.component';
import {ImportProgressModalComponent} from '../modals/import-progress-modal/import-progress-modal.component';
import {ErrorHandlingService} from '../../shared/services/error-handling-service';
import {DefaultService} from '../../../gen/swagger-api/api/default.service';
import {AuthService} from '../../shared/services/auth/auth.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'app-card-groups',
  templateUrl: './card-groups.component.html',
  styleUrls: ['./card-groups.component.css']
})
export class CardGroupsComponent implements OnInit {


  public cardGroups: Array<CARDGROUPINFOCUSTOM> = [];
  public filteredCardGroups: Array<CARDGROUPINFOCUSTOM> = [];

  public currentCardPools: Array<CARDGROUPINFOCUSTOM> = [];
  public currentFilteredPools: Array<CARDGROUPINFOCUSTOM> = [];
  private defaultService: DefaultService;
  private helpService: DefaultServiceGetSubscriptionPools;
  public username: string;
  public showConfigButton = false;
  public showOperationButton = false;
  public cardGroupId: string;
  private bsModalRef: BsModalRef;
  public cardsList: Array<CARDINFO>;
  public filteredCardList: Array<CARDINFO>;
  private alertService: AlertService;
  public selectedCardGroupOwnerIds: string;
  public selectedPoolIds: Array<number> = [];
  public selectedCardGroupIds: Array<string> = [];
  public failedDeletedCardGroups: Array<string> = [];
  public failedDeletedIds: Array<string> = [];
  operationsDisabled: boolean = this.selectedPoolIds.length === 0;
  public permissions: Array<string> = [];
  public tabView = 'home';
  private modalService: BsModalService;
  public cardGroupSelected: CARDGROUPINFOCUSTOM;
  private httpOperationsService: HttpOperationsService;
  private _cardGroupFilterCriteria: string;
  private _cardPoolConfigFilterCriteria: string;
  public selectCards: Array<string> = [];
  public showSaveButton = false;
  public showCancelButton = false;
  public subcsriptionService: SubscriptionService;
  public newCardGroupForm: FormGroup;
  offset = 0;
  offsetBootstrap = 0;
  offsetCards = 0;
  private _cardGroupContentFilterCriteria: string;
  private _ownerContentFilterCriteria: string;
  static readonly LIMIT: number = 50;
  activeTab = 'home';
  editMode = false;
  newMode = false;
  viewMode = false;
  @ViewChild('checkCards') checkCards;

  /**----------------------------------------------------------------------------
   * constructor
   *-----------------------------------------------------------------------------*/
  constructor(defaultService: DefaultService,
              modalService: BsModalService,
              alertService: AlertService,
              httpOperationsService: HttpOperationsService,
              subcsriptionService: SubscriptionService,
              helpService: DefaultServiceGetSubscriptionPools,
              private authenticationService: AuthService,
              private fb: FormBuilder,
              private errorHandlingService: ErrorHandlingService) {
    this.defaultService = defaultService;
    this.helpService = helpService;
    this.modalService = modalService;
    this.cardGroups = [];
    this.alertService = alertService;
    this.httpOperationsService = httpOperationsService;
    this.subcsriptionService = subcsriptionService;
    this.offset = 0;
    this.offsetBootstrap = 0;
  }


  /**----------------------------------------------------------------------------
   * ngOnInit
   *-----------------------------------------------------------------------------*/
  ngOnInit() {
    this.username = sessionStorage.getItem('username');
    this.offset = 0;
    this.loadCardGroups(this.offset);
  }


  /**----------------------------------------------------------------------------
   * loadCardGroups
   *-----------------------------------------------------------------------------*/
  public loadCardGroups(offset?: number, sortColumn?: string, direction?: string) {
    this._cardGroupFilterCriteria = '';
    this.offset = this.offset;
    this.helpService.cardGroupsGet(offset, CardGroupsComponent.LIMIT).subscribe(cardGroups => {
        this.cardGroups = cardGroups;
        if (sortColumn === 'groupName' && direction === 'desc') {
          this.filteredCardGroups = this.cardGroups.sort((a, b) => a.groupName > b.groupName ? -1 : 1);
        } else if (sortColumn === 'groupName' && direction === 'asc') {
          this.filteredCardGroups = this.cardGroups.sort((a, b) => a.groupName < b.groupName ? -1 : 1);
        } else if (sortColumn === 'description' && direction === 'asc') {
          this.filteredCardGroups = this.cardGroups.sort((a, b) => a.description < b.description ? -1 : 1);
        } else if (sortColumn === 'description' && direction === 'desc') {
          this.filteredCardGroups = this.cardGroups.sort((a, b) => a.description > b.description ? -1 : 1);
        } else {
          this.filteredCardGroups = this.cardGroups.sort((a, b) => a.groupName < b.groupName ? -1 : 1);
        }
      },
      (error) => {
        this.filteredCardGroups = [];
        if (!error.status || error.status != 404) {
            this.errorHandlingService.errorHandling(error);
        }
      });
  }


  /**----------------------------------------------------------------------------
   * filterCardGroups
   *-----------------------------------------------------------------------------*/
  public filterCardGroups(filterBy: string) {
    filterBy = filterBy.toLocaleLowerCase();
    return this.cardGroups.filter((cardGroup: CARDGROUPINFOCUSTOM) =>
      (cardGroup.groupName.toLocaleLowerCase()).indexOf(filterBy) !== -1
    );
  }


  /**----------------------------------------------------------------------------
   * get cardGroupFilterCriteria
   *-----------------------------------------------------------------------------*/
  get cardGroupFilterCriteria(): string {
    return this._cardGroupFilterCriteria;
  }


  /**----------------------------------------------------------------------------
   * set cardGroupFilterCriteria
   *-----------------------------------------------------------------------------*/
  set cardGroupFilterCriteria(value: string) {
    this._cardGroupFilterCriteria = value;
    this.filteredCardGroups = this.cardGroupFilterCriteria ? this.filterCardGroups(this._cardGroupFilterCriteria) : this.cardGroups;
  }


  /**----------------------------------------------------------------------------
   * filterCardPoolConfiguration
   *-----------------------------------------------------------------------------*/
  public filterCardPoolConfiguration(filterBy: string) {
    filterBy = filterBy.toLocaleLowerCase();
    return this.currentCardPools.filter((subscriptionPoolInfo: CARDGROUPINFOCUSTOM) =>
      subscriptionPoolInfo.groupName.toLocaleLowerCase().indexOf(filterBy) !== -1
    );
  }


  /**----------------------------------------------------------------------------
   * get cardPoolConfigurationFilterCriteria
   *-----------------------------------------------------------------------------*/
  get cardPoolConfigurationFilterCriteria(): string {
    return this._cardPoolConfigFilterCriteria;
  }


  /**----------------------------------------------------------------------------
   * set cardPoolConfigurationFilterCriteria
   *-----------------------------------------------------------------------------*/
  set cardPoolConfigurationFilterCriteria(value: string) {
    this._cardPoolConfigFilterCriteria = value;
    this.currentFilteredPools = this.cardPoolConfigurationFilterCriteria ? this.filterCardPoolConfiguration(this._cardPoolConfigFilterCriteria) : this.currentCardPools;
  }


  /**----------------------------------------------------------------------------
   * filterCardGroupContent
   *-----------------------------------------------------------------------------*/
  public filterCardGroupContent(filterBy: string) {
    filterBy = filterBy.toLocaleLowerCase();
    return this.cardsList.filter((cardInfo: CARDINFO) => cardInfo.currentSubscription.iccid.toLocaleLowerCase().indexOf(filterBy) !== -1);
  }


  /**----------------------------------------------------------------------------
   * get cardGroupContentFilterCriteria
   *-----------------------------------------------------------------------------*/
  get cardGroupContentFilterCriteria(): string {
    return this._cardGroupContentFilterCriteria;
  }


  /**----------------------------------------------------------------------------
   * set cardGroupContentFilterCriteria
   *-----------------------------------------------------------------------------*/
  set cardGroupContentFilterCriteria(value: string) {
    this._cardGroupContentFilterCriteria = value;
    this.filteredCardList = this.cardGroupContentFilterCriteria ? this.filterCardGroupContent(this._cardGroupContentFilterCriteria) : this.cardsList;
  }


  /**----------------------------------------------------------------------------
   * onScrollDown
   *-----------------------------------------------------------------------------*/
  public onScrollDown() {
    this.offset = this.offset + CardGroupsComponent.LIMIT;

    this.helpService.cardGroupsGet(this.offset, CardGroupsComponent.LIMIT).subscribe(cardGroups => {
        this.cardGroups = this.cardGroups.concat(cardGroups);
      },
      (error) => {
        this.errorHandlingService.errorHandling(error);
      });
  }


  /**----------------------------------------------------------------------------
   * onSortedCardGroups
   *-----------------------------------------------------------------------------*/
  onSortedCardGroups($sortEvent1) {
    this.offset = 0;
    this.loadCardGroups(this.offset, $sortEvent1.sortColumn, $sortEvent1.sortDirection);
  }


  /**----------------------------------------------------------------------------
   * onToggleSelectedElement
   *-----------------------------------------------------------------------------*/
  public onToggleSelectedElement(id) {
    if (this.selectedPoolIds.includes(id)) {
      const index = this.selectedPoolIds.findIndex(d => d === id); // find index in your array
      this.selectedPoolIds.splice(index, 1); // remove element from array
    } else {
      this.selectedPoolIds.push(id);
    }
    this.operationsDisabled = this.selectedPoolIds.length === 0;
  }


  /**----------------------------------------------------------------------------
   * onToggleSelectedCardGroup
   *-----------------------------------------------------------------------------*/
  public onToggleSelectedCardGroup(id) {
    if (this.selectedCardGroupIds.includes(id)) {
      const index = this.selectedCardGroupIds.findIndex(d => d === id); // find index in your array
      this.selectedCardGroupIds.splice(index, 1); // remove element from array
    } else {
      this.selectedCardGroupIds.push(id);
    }
    this.operationsDisabled = this.selectedCardGroupIds.length === 0;
  }


  /**----------------------------------------------------------------------------
   * checkAllCardGroups
   *-----------------------------------------------------------------------------*/
  public checkAllCardGroups(ev) {
    this.cardGroups.forEach(x => {
      if (ev.target.checked) {
        this.selectedCardGroupIds.push(x.cardGroupId);
      } else {
        this.selectedCardGroupIds = [];
      }
    });
    this.operationsDisabled = this.selectedCardGroupIds.length === 0;
  }


  /**----------------------------------------------------------------------------
   * getCardGroupById
   *-----------------------------------------------------------------------------*/
  public getCardGroupById(id: number) {
    let selectedCardGroup;
    this.cardGroups.forEach(cardGroup => {
      if (cardGroup !== null && cardGroup.cardGroupId === id.toString()) {
        selectedCardGroup = cardGroup;
        return;
      }
    });
    return selectedCardGroup;
  }


  /**----------------------------------------------------------------------------
   * addNewCardGroup
   *-----------------------------------------------------------------------------*/
  public addNewCardGroup() {
    this.newMode = true;
    this.editMode = false;
    this.viewMode = false;
    this.newCardGroupForm = this.fb.group({
      cardGroupId: [''],
      groupName: ['', [Validators.required]],
      description: ['', [Validators.required]]
    });
    this.activeTab = 'home';
    this.tabView = 'home';
  }


  /**----------------------------------------------------------------------------
   * cancelNewPool
   *-----------------------------------------------------------------------------*/
  public cancelNewPool() {
    if (this.viewMode === false && this.editMode === false && !this.cardGroupSelected) {
      this.viewMode = false;
      this.newMode = false;
      this.editMode = false;
      this.newCardGroupForm = null;
    } else {
      this.viewMode = true;
      this.newCardGroupForm = this.fb.group({
        cardGroupId: [''],
        groupName: ['', [Validators.required]],
        description: ['', [Validators.required]]
      });
      this.newCardGroupForm.patchValue(this.cardGroupSelected);
      this.newMode = false;
      this.editMode = false;
    }
  }


  /**----------------------------------------------------------------------------
   * editCardGroups
   *-----------------------------------------------------------------------------*/
  public editCardGroups(cardGroupDetails: any) {
    this.editMode = true;
    this.newMode = false;
    this.viewMode = false;
    this.newCardGroupForm = this.fb.group({
      cardGroupId: [''],
      groupName: ['', [Validators.required]],
      description: ['', [Validators.required]]
    });

    this.newCardGroupForm.patchValue(cardGroupDetails);
  }


  /**----------------------------------------------------------------------------
   * changeTabToHome
   *-----------------------------------------------------------------------------*/
  public changeTabToHome() {
    this.activeTab = 'home';
    this.tabView = 'home';
    this.onCardGroupSelected(this.cardGroupSelected);
  }


  /**----------------------------------------------------------------------------
   * changeTabToContentBrowser
   *-----------------------------------------------------------------------------*/
  public changeTabToContentBrowser() {
    this.activeTab = 'menu1';
    this.tabView = 'tab1';
    this.onCardGroupSelected(this.cardGroupSelected);
  }

  /**----------------------------------------------------------------------------
   * onCardGroupSelected
   *-----------------------------------------------------------------------------*/
  public onCardGroupSelected(cardGroup: CARDGROUPINFOCUSTOM) {
    if (cardGroup) {
      this.viewMode = true;
      this.editMode = false;
      this.newMode = false;

      if (this.checkCards) {
        this.checkCards.nativeElement.checked = false;
      }
      this.newCardGroupForm = this.fb.group({
        cardGroupId: [''],
        groupName: ['', [Validators.required]],
        description: ['', [Validators.required]]
      });

      this.newCardGroupForm.patchValue(cardGroup);
      this.cardGroupSelected = cardGroup;
      this.offsetBootstrap = 0;
      this.offsetCards = 0;
      if (cardGroup) {
        this.cardGroupId = cardGroup.cardGroupId;
        this.selectCards = [];

        if (this.tabView === 'tab1') {
          this.loadCards(this.cardGroupSelected, this.offsetCards);
          this.showOperationButton = true;
          this.showConfigButton = false;
          this.showSaveButton = false;
          this.showCancelButton = false;
        } else if (this.tabView === 'home') {
          this.showOperationButton = false;
          this.showSaveButton = false;
          this.showCancelButton = false;
        }
      }
    }
  }


  /**----------------------------------------------------------------------------
   * deleteCardGroups
   *-----------------------------------------------------------------------------*/
  public deleteCardGroups() {
    if (this.selectedCardGroupIds.length !== 0) {
      const initialState = {};
      this.bsModalRef = this.modalService.show(DeleteQuestionModalComponent, {initialState});
      this.bsModalRef.content.closeBtnName = 'Close';
      this.bsModalRef.content.type = 'cards';
      this.bsModalRef.content.action.take(1).subscribe((value) => {
        if (value === true) {
          this.deleteRecursion(0);
        }
      });
    }
  }


  /**----------------------------------------------------------------------------
   * deleteRecursion
   *-----------------------------------------------------------------------------*/
  private deleteRecursion(index) {
    const a = this.selectedCardGroupIds[index];
    this.defaultService.cardGroupsCardGroupIdDelete(this.selectedCardGroupIds[index]).subscribe(x => {
      index = index + 1;
      if (index < this.selectedCardGroupIds.length) {
        this.deleteRecursion(index);
      } else {
        this.afterDelete();
        return;
      }
    }, (error) => {
      this.filteredCardGroups.filter((cg) => cg.cardGroupId === this.selectedCardGroupIds[index]).map(x => {
        this.failedDeletedCardGroups.push(x.groupName + ' - ' + this.handleError(error));
        this.failedDeletedIds.push(x.cardGroupId);
      });
      index = index + 1;
      if (index < this.selectedCardGroupIds.length) {
        this.deleteRecursion(index);
      } else {
        this.afterDelete();
        return;
      }
    });
  }


  /**----------------------------------------------------------------------------
   * handleError
   *-----------------------------------------------------------------------------*/
  private handleError(error) {
    if (error instanceof HttpErrorResponse) {
      // Server or connection error happened
      switch (error.status) {
        case 0:
          // API not reachable?
          return 'Please check connection.';
        case 500:
          return 'Internal server error';
        case 400:
        case 409:
          return 'Conflict';
        case 403:
          return 'Operation is not allowed for the user';
        default:
          return 'Error details: none';
      }
    } else {
      return '';
    }
  }


  /**----------------------------------------------------------------------------
   * afterDelete
   *-----------------------------------------------------------------------------*/
  private afterDelete() {
    if (this.failedDeletedCardGroups.length !== 0) {
      this.alertService.errors(this.failedDeletedCardGroups, [], 'deleteCardGroups', false, 'The following groups were not deleted:');
      this.resetTabs();
      this.failedDeletedCardGroups = new Array<string>();
    } else {
      this.resetTabs();
      this.alertService.successModal('Successfully deleted card groups');
    }
    this.newCardGroupForm = null;
    this.cardGroupSelected = null;
    this.selectedCardGroupIds = new Array<string>();
    this.loadCardGroups(0);
  }


  /**----------------------------------------------------------------------------
   * resetTabs
   *-----------------------------------------------------------------------------*/
  private resetTabs() {
    if (this.selectedCardGroupIds.includes(this.cardGroupId) && !this.failedDeletedIds.includes(this.cardGroupId)) {
      this.currentFilteredPools = new Array<CARDGROUPINFOCUSTOM>();
      this.cardGroupId = undefined;
      this.filteredCardList = new Array<CARDINFO>();
    }

  }


  /**----------------------------------------------------------------------------
   * onToggleSelectedOwnersElement
   *-----------------------------------------------------------------------------*/
  public onToggleSelectedOwnersElement(accountId) {
    this.showSaveButton = true;
    this.showCancelButton = true;
    this.selectedCardGroupOwnerIds = accountId;
  }


  /**----------------------------------------------------------------------------
   * loadCards
   *-----------------------------------------------------------------------------*/
  public loadCards(cardGroup: CARDGROUPINFOCUSTOM, offset: number) {
    this.offsetCards = offset;
    if (cardGroup !== undefined) {
      this._cardGroupContentFilterCriteria = '';
      // this.defaultService.cardGroupsGroupIdCardsGet(cardGroup.cardGroupId, offset, CardGroupsComponent.LIMIT_CARDS).subscribe((items) => {
      this.defaultService.cardGroupsCardGroupIdCardsGet(cardGroup.cardGroupId).subscribe((items) => {
          this.cardsList = items;
          this.filteredCardList = items;
        },
        (error) => {
          this.errorHandlingService.errorHandling(error);
        });
    }
  }


  /**----------------------------------------------------------------------------
   * openCardDetailsModal
   *-----------------------------------------------------------------------------*/
  public openCardDetailsModal(cardInfo: CARDINFO) {
    const showButton = false;
    const fromCardPool = true;
    const initialState = {
      cardInfo,
      showButton,
      fromCardPool
    };
    this.bsModalRef = this.modalService.show(CardDetailsModalComponent, {initialState, class: 'modal-large'});
    this.bsModalRef.content.closeBtnName = 'Close';
  }


  /**----------------------------------------------------------------------------
   * openAuditModal
   *-----------------------------------------------------------------------------*/
  public openAuditModal(subscription: CARDINFO) {
    const subscriptions: Array<CARDINFO> = [subscription];

    const callback = () => {
    };

    const initialState = {
      subscriptions,
      callback
    };
    this.bsModalRef = this.modalService.show(AuditModalComponent, {initialState});
    this.bsModalRef.content.closeBtnName = 'Close';
  }


  /**----------------------------------------------------------------------------
   * openHistoryModal
   *-----------------------------------------------------------------------------*/
  public openHistoryModal(subscription: CARDINFO) {
    const callback = () => {
      // this.closeModal();
    };

    const initialState = {
      subscription,
      callback
    };
    this.bsModalRef = this.modalService.show(HistoryModalComponent, {initialState, class: 'modal-large'});
    this.bsModalRef.content.closeBtnName = 'Close';
  }


  /**----------------------------------------------------------------------------
   * selectOperation
   *-----------------------------------------------------------------------------*/
  public selectOperation(operation: string) {
    let title = '';
    if (operation === 'move') {
      title = 'MOVE CARDS';
    }
    if (operation === 'delete') {
      title = 'DELETE CARDS';
    }
    const subtitle = '';
    const cards = this.selectCards;
    const sourceCard = this.cardGroupSelected;
    const menu = 'CARD';
    const initialState = {
      operation,
      title,
      subtitle,
      cards,
      sourceCard,
      menu
    };

    if (operation === 'move') {
      this.bsModalRef = this.modalService.show(SelectionOperationModalComponent, {initialState});
    } else if (operation === 'delete') {
      this.bsModalRef = this.modalService.show(ScDeleteCardsModalComponent, {initialState});
    }
    this.bsModalRef.content.closeBtnName = 'Close';
    this.bsModalRef.content.action.take(1).subscribe((value) => {
        if (value) {
          if (operation === 'move') {
            this.alertService.successModal('Move completed successfully');
          }
          if (operation === 'delete') {
            this.alertService.successModal('Cards deleted successfully');
          }
          if (this.checkCards) {
            this.checkCards.nativeElement.checked = false;
          }
          this.selectCards = [];
          this.loadCards(this.cardGroupSelected, 0);

        } else {
          this.selectCards = [];
          this.loadCards(this.cardGroupSelected, 0);
        }
      },
      (error) => {
        this.errorHandlingService.errorHandling(error);
      });
  }


  /**----------------------------------------------------------------------------
   * onToggleSelectedElementCards
   *-----------------------------------------------------------------------------*/
  public onToggleSelectedElementCards(ev) {
    const iccid = ev.target.value;
    if (this.selectCards.includes(iccid)) {
      const index = this.selectCards.findIndex(d => d === iccid); // find index in your array
      this.selectCards.splice(index, 1); // remove element from array
    } else {
      this.selectCards.push(iccid);
    }
    this.operationsDisabled = this.selectCards.length === 0;
  }


  /**----------------------------------------------------------------------------
   * checkAll
   *-----------------------------------------------------------------------------*/
  public checkAll(ev) {
    if (this.tabView === 'tab1') {
      this.cardsList.forEach(x => {
        if (ev.target.checked) {
          this.selectCards.push(x.eis.eid);
        } else {
          this.selectCards = [];
        }
      });
    }
  }


  /**----------------------------------------------------------------------------
   * importCards
   *-----------------------------------------------------------------------------*/
  importCards() {
    const inputData = {
      cardGroup: this.cardGroupSelected.groupName
    };
    this.bsModalRef = this.modalService.show(ImportCardsModalComponent);
    this.bsModalRef.content.inputData = inputData;
    this.bsModalRef.content.action.take(1).subscribe((value) => {
      if (value) {

        const status = value['state'];
        const filename = value['filename'];
        const formData = value;
        const type = 'cards';
        const initialState = {
          status,
          filename,
          formData,
          type
        };

        this.bsModalRef = this.modalService.show(ImportProgressModalComponent, {
          initialState,
          ignoreBackdropClick: true,
          keyboard: false
        });
        this.bsModalRef.content.action.take(1).subscribe((v) => {
          if (v) {
            this.loadCards(this.cardGroupSelected, 0);
          }
        });
      }
    });
  }


  /**----------------------------------------------------------------------------
   * saveCardGroup
   *-----------------------------------------------------------------------------*/
  public saveCardGroup(): void {
    if (this.newCardGroupForm.value.groupName === '' || this.newCardGroupForm.value.description === '') {
      this.setToDirty();
    } else if (this.newCardGroupForm.valid) {
      this.defaultService.cardGroupsPut(this.newCardGroupForm.value).subscribe((item) => {
          this.loadCardGroups(0);
          this.alertService.successModal('New Card group created');
        },
        (error) => {
          if (error) {
            this.errorHandlingService.errorHandling(error);
          }
        });
      this.newCardGroupForm = null;
      this.newCardGroupForm = null;
      this.newMode = false;
      this.viewMode = false;
      this.editMode = false;
    }
  }


  /**----------------------------------------------------------------------------
   * updateCardGroup
   *-----------------------------------------------------------------------------*/
  public updateCardGroup({value}: { value: CARDGROUPINFO }) {

    if (this.newCardGroupForm.value.groupName === '' || this.newCardGroupForm.value.description === '') {
      this.setToDirty();
    } else if (this.newCardGroupForm.valid) {
      this.defaultService.cardGroupsCardGroupIdPost(value.cardGroupId, value).subscribe(x => {
        this.newCardGroupForm = null;
        this.loadCardGroups(0);
        this.onCardGroupSelected(x);
        this.alertService.successModal('Card group edited');
      }, error1 => {
        this.errorHandlingService.errorHandling(error1);
      });
      this.newCardGroupForm = null;
      this.newMode = false;
      this.viewMode = false;
      this.editMode = false;
    }
  }


  /**----------------------------------------------------------------------------
   * setToDirty
   *-----------------------------------------------------------------------------*/
  setToDirty() {
    this.newCardGroupForm.controls.groupName.markAsDirty();
    this.newCardGroupForm.controls.description.markAsDirty();
  }
}



// WEBPACK FOOTER //
// ./src/app/achelos-iot/card-groups/card-groups.component.ts